import * as R from "ramda";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { showNotification, withDataProvider } from "react-admin";
import Button from "@material-ui/core/Button";
import { dataProvider } from "../../App";
import { SEND_CLINIC_INVITATION_EMAIL } from "../../misc/constants";

class SendClinicInvitationButton extends Component {
  handleClick = () => {
    const { record } = this.props;
    dataProvider(SEND_CLINIC_INVITATION_EMAIL, undefined, { id: record.id })
      .then(() => {
        this.props.dispatch(showNotification("Email has been sent"));
      })
      .catch((err) => {
        const message = R.pathOr(
          "Error: email won't send",
          ["body", "message"],
          err
        );
        this.props.dispatch(showNotification(message, "warning"));
      });
  };

  render() {
    return (
      <Button disabled={this.props.disabled} onClick={this.handleClick}>
        Send email
      </Button>
    );
  }
}

SendClinicInvitationButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  showNotification: PropTypes.func.isRequired,
  record: PropTypes.object,
};

export default withDataProvider(SendClinicInvitationButton);
